import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import { DataTableWrapper } from "../../../../components/data/DataTable";
import XrInputAv from "../../../../components/XrInputAv";
import XrButtonAv from "../../../../components/XrButtonAv";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { setBooking } from "../../../../redux/reducers/bookings/actions";
import React, { useState } from "react";
import { EnumStatus } from "../../../../interfaces/Enums";

const BookingManageInventories = () => {
  const dispatch = useDispatch();
  const [updateIncr, forceUpdate] = useState(false);
  const booking = useSelector((state: RootState) => state.booking.selectedBooking);

  const disableChange = !(booking && booking.status === 0) || false;
  
  const onChangeDescription = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
    if (!booking) return;
    const inventories = booking.inventories;
    inventories[index].description = e.target.value
    dispatch(setBooking({
      ...booking,
      inventories
    }));
  }

  const actionDeleteInventory = (index: number) => {
    if (!booking) return;
    const inventories = booking.inventories;
    inventories.splice(index, 1);
    forceUpdate(!updateIncr);
    dispatch(setBooking({
      ...booking,
      inventories
    }));
  }

  const onChangeApproval = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
    if (!booking) return;
    const inventories = booking.inventories;
    forceUpdate(!updateIncr);
    if (e.target.checked) {
      inventories[index].status = EnumStatus.APPROVED;
      dispatch(setBooking({
        ...booking,
        inventories
      }));
    } else {
      inventories[index].status = EnumStatus.REJECTED;
      dispatch(setBooking({
        ...booking,
        inventories
      }));
    }
  }

  return (
    <DataTableWrapper style={{ margin: '0px' }}>
      <div className="tablewrapper--table">
        <table>
          <thead>
            <tr>
              <th>Nama</th>
              <th>Setujui</th>
              <th>Keterangan</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {booking?.inventories.map((inventory, index) => (
              <tr key={index}>
                <td>{inventory.inventory_detail?.item_name}</td>
                <td width={30}>
                  <input type='checkbox'
                    disabled={disableChange}
                    checked={inventory.status === EnumStatus.APPROVED}
                    onChange={(e) => onChangeApproval(index, e)}
                  />
                </td>
                <td>
                  <XrInputAv
                    type='text'
                    required={false}
                    disabled={disableChange}
                    value={inventory.description}
                    onChange={(e) => onChangeDescription(index, e)}
                  />
                </td>
                <td>
                  <XrButtonAv
                    noBlock
                    size='small'
                    color='danger'
                    icon={faTrash}
                    disabled={disableChange}
                    onClick={() => actionDeleteInventory(index)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DataTableWrapper>
  );
}

export default BookingManageInventories;